import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import iconW from './imgs/logo.png'
import account from './imgs/User.png'
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [
    { label: 'Vietnam Overview', path: '/' },
    { label: 'Our Work', path: '/gioi-thieu' },
    { label: 'Our Insights', path: '/loai-phong' },
    { label: 'Carees', path: '/am-thuc' },
    { label: 'Contact Us', path: '/hinh-anh' }
  ];


  return (
    <nav className="bg-black/0 backdrop-blur-md text-white transition-colors duration-300 fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between  h-150 pt-4" >

          {/* Logo */}
          <div className="flex items-center space-x-2 ">
            <div>
              <img
                className="h-16 w-auto"
                src={iconW}
                alt="CLEAVER"
              />
            </div>


          </div>

          {/* Desktop Trang chủ */}
          <div className="hidden md:flex space-x-6 text-sm">
            <div className=" underline-offset-4 transition-all">
              Vietnam Overview
            </div>
          </div>
          {/* Desktop Giới Thiệu */}
          <div className="hidden md:flex space-x-6 text-sm">
            <div className=" underline-offset-4 transition-all">
              Our Work
            </div>
          </div>
          {/* Desktop Loại Phòng */}
          <div className="hidden md:flex space-x-6 text-sm">
            <div className=" underline-offset-4 transition-all">
              Our Insights
            </div>
          </div>
          {/* Desktop Ẩm Thực */}
          <div className="hidden md:flex space-x-6 text-sm">
            <div className=" underline-offset-4 transition-all">
              Carees
            </div>
          </div>
          {/* Desktop Combo Package */}
          <div className="hidden md:flex space-x-6 text-sm">
            <div className=" underline-offset-4 transition-all">
              Contact Us
            </div>
          </div>

          <div className="hidden md:flex space-x-6 text-sm">
            <div className=" underline-offset-4 transition-all">
              <div className="hidden md:flex items-center space-x-2 text-sm">
                <img size={16} src={account} />
                <div className=' underline-offset-4 transition-all'>Account</div>
              </div>
            </div>
          </div>

          {/* Contact (Desktop) */}
         




          {/* Mobile Menu Icon */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-black/50 text-white px-4 py-4 space-y-4">
          {navItems.map((item, index) => (
            <div
              key={index}
              className="block text-sm  underline-offset-4"
              onClick={() => setIsOpen(false)} // đóng menu sau khi bấm
            >
              {item.label}
            </div>
          ))}
        </div>
      )}

    </nav>
  );
};

export default Navbar;
